/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { AssistanceModalSize } from './enums';
import MuiDialog from '@material-ui/core/Dialog';
import { AssistanceModalCloseButton } from './AssistanceModalCloseButton';
import { AssistanceModalFooter } from './AssistanceModalFooter';
import { Magnetic } from "../../styles/Semantic";
import styled from '@emotion/styled';
import { AssistanceModalBody } from './AssistanceModalBody';
const dialogCss = ({ maxWidth }) => css `
	width: 100%;
	.MuiBackdrop-root {
		background: ${Magnetic.veilBackgroundColor};
	}
	.MuiPaper-root {
		min-width: 500px;
		border-radius: ${Magnetic.modalBorderRadius};
		margin: 0 ${Magnetic.spacer08};
		box-shadow: ${Magnetic.modalBoxShadow};
	}
	@media only screen and (max-width: ${Magnetic.layoutBreakpointSm}) {
		.MuiPaper-root {
			min-width: 0;
		}
	}
	.MuiDialog-paper {
		max-width: ${maxWidth || AssistanceModalSize.S};
	}
	.MuiDialog-scrollBody {
		display: 'flex';
		align-items: 'center';
	}
`;
const AssistanceModalHeader = styled.div `
	display: flex;
	justify-content: flex-end;
	padding: ${Magnetic.assistanceModalHeaderPadding};
`;
const FooterContainer = styled.div `
	padding: ${Magnetic.assistanceModalFooterPadding};
`;
/**
 * Props for AssistanceModal component
 * @param {boolean} isOpen to open the Modal
 * @param {UamType} type to determines iconClass and color
 * @param {string} title title of the modal
 * @param {string} customIcon  to override the default icon associated with the user assistance type
 * @param {AssistanceModalSize} maxWidth Custom mapping that follows our Assistance Modal documentation
 * @param {ReactNode | string} children the content the component wraps
 * @param {ReactNode} customFooter to override the default footer
 * @param {string} tertiary to display tertiary button with text
 * @param {string} secondary to display secondary button with text
 * @param {string} primary to display primary button with text
 * @param {boolean} isPrimaryButtonDisabled to disable primary button
 * @param {function():void} onClose callback triggered when close icon is clicked
 * @param {function():void} onTertiaryClick callback triggered when tertiary button is clicked
 * @param {function():void} onSecondaryClick callback triggered when secondary button is clicked
 * @param {function():void} onPrimaryClick callback triggered when primary button is clicked
 * @param {isBusy} isBusy to load the spinner for the Button when the component is Busy
 * @param {shouldHideClose} shouldHideClose to hide close icon from header
 */
export const AssistanceModal = (props) => {
    const { isOpen, onClose, tertiary, secondary, primary, isPrimaryButtonDisabled, isBusy, onTertiaryClick, onSecondaryClick, onPrimaryClick, maxWidth, customFooter, children, type, title, customIcon, shouldHideClose } = props;
    return (jsx(MuiDialog, { open: !!isOpen, onClose: onClose, css: dialogCss({ maxWidth }) },
        jsx(AssistanceModalHeader, null, !shouldHideClose && jsx(AssistanceModalCloseButton, { onClose: onClose, isBusy: isBusy })),
        jsx(AssistanceModalBody, { children: children, type: type, title: title, customIcon: customIcon, shouldHideClose: shouldHideClose }),
        jsx(FooterContainer, null, customFooter || (jsx(AssistanceModalFooter, { tertiary: tertiary, secondary: secondary, primary: primary, isPrimaryButtonDisabled: isPrimaryButtonDisabled, onTertiaryClick: onTertiaryClick, onSecondaryClick: onSecondaryClick, onPrimaryClick: onPrimaryClick, isBusy: isBusy })))));
};
//# sourceMappingURL=AssistanceModal.js.map